var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirddesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 189,
    viewBox: "0 0 186 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.975 184.738L76.709 158.92L81.669 185.993L68.975 184.738ZM91.501 158.987L102.809 184.043L90.19 185.926L91.501 158.987ZM45.491 175.026L62.184 153.957L56.815 180.949L45.491 175.026ZM110.261 152.8L130.398 171.382L119.521 178.102L110.261 152.8ZM24.423 161.88L45.681 145.522L33.987 170.4L24.423 161.88ZM124.332 145.522L149.27 156.707L141.065 166.558L124.332 145.522ZM8.14502 141.858L33.054 132.058L15.006 152.7L8.14502 141.858ZM132.145 126.852L158.874 132.417L152.939 143.807L132.145 126.852ZM0.0830078 117.341L26.745 115.314L3.49701 129.738L0.0830078 117.341ZM140.932 111.675L167.997 108.162L166.06 120.88L140.932 111.675ZM3.43201 89.313L27.291 101.485L0 101.705L3.43201 89.313ZM139.77 92.994L164.023 80.3719L166.507 92.994H139.77ZM6.69598 77.627L12.64 66.2419L33.42 83.214L6.69598 77.627ZM152.773 59.459L158.416 71L132.595 78L152.773 59.459ZM18.895 55.449L27.895 46.335L42.795 68.73L18.895 55.449ZM134.695 40.223L143.644 49.391L121.297 64.21L134.695 40.223ZM37.453 37.156L49.076 31.856L55.133 58.127L37.453 37.156ZM113.704 27.073L124.931 33.181L107.901 53.974L113.704 27.073ZM61.657 26.473L74.382 25.594L70.982 52.347L61.657 26.473ZM86.876 24L99.576 25.151L92.044 51.031L86.876 24Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 168,
    height: 168,
    rx: 84,
    fill: "#D9D9D9",
    fillOpacity: 0.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirddesign);
export default __webpack_public_path__ + "static/media/thirddesign.b0531ac0759449ce0a4ecf5c89d02936.svg";
export { ForwardRef as ReactComponent };